import axios from 'axios';
import { apiClient } from './client';

type ChatConversationEntry = {
  role: 'user' | 'assistant';
  content: string;
};

export type AiChatLog = {
  id: number;
  session_id: string;
  celebration_id: number | null;
  status: string;
  confirmed_tags?: Record<string, string[]> | null;
  conversation: ChatConversationEntry[];
  created_at: string;
  completed_at: string;
};

export async function attachChatLogToCelebration(sessionId: string, celebrationId: number): Promise<AiChatLog> {
  const response = await apiClient.post('/ai-chat/attach', { sessionId, celebrationId });
  return response.data.data as AiChatLog;
}

export async function getChatLogForCelebration(celebrationId: number): Promise<AiChatLog | null> {
  try {
    const response = await apiClient.get(`/ai-chat/celebrations/${celebrationId}`);
    return (response.data.data as AiChatLog) ?? null;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      return null;
    }

    throw error;
  }
}
